
// AdminEmployees.jsx
import React, { useState } from 'react';
import {Mail, FileText, Plug  } from 'lucide-react';
import TabPageLayout from 'modules/swiftboard/components/TabPageLayout';
import EmailAuditTrail from './email-audit-trail/EmailAuditTrail';
import useUrlTab from "modules/swiftboard/components/useUrlTab";
const Activities = () => {
  const [activeTab, setActiveTab] = useUrlTab(["email-audit-trail", "tracking", "email-api"]);
  const [unreadCount, setUnreadCount] = useState(0);

  const Tabs = [
    {
      id: 1,
      label: 'Email Audit Trail',
      icon: <Mail size={18} />,
      badge: unreadCount > 0
      ? {
          count: unreadCount,
          type: "count",   // 👈 this will show red dot
        }
      : null,
    },
    {
      id: 2,
      label: 'Tracking',
      icon: <FileText size={18} />,
    },
    {
      id: 3,
      label: 'Email API',
      icon: <Plug size={18} />,
    }
  ];


  const handleTabChange = (index, tab) => {
    setActiveTab(index);
  };
 

  return (
    <TabPageLayout
      tabs={Tabs}
      activeTab={activeTab}
      onTabChange={handleTabChange}
    >
      {activeTab === 0 && <EmailAuditTrail onUnreadChange={setUnreadCount} />}
      {/* {activeTab === 1 && <  />} */}
    </TabPageLayout>
  );
};

export default Activities;